export default "__VITE_ASSET__D$zeQ7qQ__"